import React from "react";
import { useNavigate } from "react-router-dom";
import "./Form_Selection_Box.css";

// A launcher tile. `icon` (a react-icon) renders in an accent-coloured badge;
// `imageUrl` is kept as a fallback for callers that still pass an image.
function FormSelectionBox({ boxName, imageUrl, icon, description, accent = "blue", navigateLink }) {
  const navigate = useNavigate();

  return (
    <button type="button" onClick={() => navigate(`${navigateLink}`)} className={`box box--${accent}`}>
      <span className="box-icon" aria-hidden="true">
        {icon || <img src={`${imageUrl}`} alt="" />}
      </span>
      <span className="box-title">{boxName}</span>
      {description && <span className="box-desc">{description}</span>}
      <span className="box-arrow" aria-hidden="true">
        →
      </span>
    </button>
  );
}

export default FormSelectionBox;
